export const GET_TASK_DASHBOARD_STATS = 'GET_TASK_DASHBOARD_STATS';
export const GET_TASK_DASHBOARD_STATS_SUCCESS = 'GET_TASK_DASHBOARD_STATS_SUCCESS';
export const GET_TASK_DASHBOARD_STATS_ERROR = 'GET_TASK_DASHBOARD_STATS_ERROR';
